<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5 mb-5">
      <div class="row">
        <div class="col-md-4">
          <lib-page-header page-title="TIPOS DE CONTRATAÇÃO" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}"
            image-title="assets/img/checklist.png">
          </lib-page-header>
        </div>
        <div class="col-md-8">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/tipos-contratacao']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" class="btn btn-outline-info btn-sm float-right mr-4">
            Salvar
          </button>
        </div>
      </div>
      <hr class="mt-1 mb-4" />
      <div class="form-row">
        <div class="col-md-5">
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="nome" class="required">Nome</label>
              <input #nome id="nome" formControlName="nome" type="text" class="form-control font-weight-bold">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-3">
              <label for="tce" class="required">TCE Nº</label>
              <input id="tce" formControlName="tce" type="text" class="form-control">
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        
        <div class="form-group col-md-4">
          <p-panel [toggleable]="true" collapseIcon="fa fa-eye" expandIcon="fa fa-eye-slash">
            <ng-template pTemplate="header">
              <div>
                <em class="fa fa-user-tie mr-1"></em>
                Modalidades de Licitação
              </div>
            </ng-template>
            <div class="table-responsive">
              <table class="table table-sm">
                <tbody>
                  <tr *ngFor="let item of listaModalidades">
                    <td class="text-center">
                      <div class="checkbox checbox-switch switch-primary" style="text-align: right;">
                        <label style="margin: 0; text-align: left;">
                          <input type="checkbox" [(ngModel)]="item.marcado"
                            [ngModelOptions]="{standalone: true}" /><span></span> &nbsp;&nbsp;
                        </label>
                      </div>
                    </td>
                    <td>{{item.modalidade.nome}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </p-panel>
        </div>
        <div class="form-group col-md-7">
          <p-panel [toggleable]="true" collapseIcon="fa fa-eye" expandIcon="fa fa-eye-slash">
            <ng-template pTemplate="header">
              <div>
                <em class="fa fa-user-tie mr-1"></em>
                Eventos contábeis
              </div>
            </ng-template>
            <app-tipo-contratacao-evento [(lista)]="listaTipoContratacaoEventos" [login]="login">
            </app-tipo-contratacao-evento>
          </p-panel>
        </div>
      </div>
    </div>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="cvs" title="Salvar" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>